import axios from 'axios';

export const findOne = async ({ newToken, id } = {}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/sail-invoices-panoramica/pinv/${id}`,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const changeStatus = async ({ data, newToken } = {}) => {
  try {
    const { id, ...body } = data;
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/sail-invoices-panoramica/pinv/change-status/${id}`,
      body,
      {
        headers: { Authorization: newToken },
      }
    );

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const sailInvoicesPanoramicaList = async (params = {}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/sail-invoices-panoramica`,
      headers: {
        Authorization: params.newToken,
      },
      params: {
        ...params,
        newToken: undefined,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const saveCachedPanoramica = async ({ data, newToken, _id } = {}) => {
  try {
    const response = await axios({
      method: 'patch',
      url: `${process.env.REACT_APP_API_URL}/sail-invoices-panoramica/${_id}`,
      data,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};
